import { createContext, useState } from "react";

export const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loggedUser, setLoggedUser] = useState(null);
  const loginHandle = () => {
    setUser(userName);
  };

  const isAuthenticated = () => {
    if (loggedUser != null) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        userName,
        setUserName,
        password,
        setPassword,
        user,
        setUser,
        loginHandle,
        isAuthenticated,
        setLoggedUser,
        loggedUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
